import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SalaryLoanInstalmentsExporter  {
    _originalTypeClassName = "zERP.BO.SalaryLoanInstalmentsExporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SalaryLoanInstalmentsExporter.translate = translateService;
}
this.SalaryLoanInstalmentsExporterKey = null;
this._key = this.SalaryLoanInstalmentsExporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _SalaryLoanInstalmentsExporterKey:any;
get SalaryLoanInstalmentsExporterKey(): any {
    return this._SalaryLoanInstalmentsExporterKey;
  }
set SalaryLoanInstalmentsExporterKey(value: any) {
    this._SalaryLoanInstalmentsExporterKey = value;
    this._key = value;
  }

static GetCollectionVariables(instalmentsTable: any): any{let vars = new window['Map']();
let instalmentsChildren = [];
instalmentsChildren?.add({
Name: "CODE",Description: "Κωδικός Εργαζομένου",}
);
instalmentsChildren?.add({
Name: "EMPLOYEEFULLNAME",Description: "Ονοματεπώνυμο Εργαζομένου",}
);
instalmentsChildren?.add({
Name: "SALARYLOANSTATUS",Description: "Κατάσταση Δανείου",}
);
instalmentsChildren?.add({
Name: "SALARY LOAN TYPE",Description: "Τύπος Δανείου",}
);
instalmentsChildren?.add({
Name: "PRINCIPAL AMOUNT",Description: "Αρχικό Κεφάλαιο",}
);
instalmentsChildren?.add({
Name: "INSTALMENTS COUNT",Description: "Αριθμός Δόσεων",}
);
instalmentsChildren?.add({
Name: "REMAINING AMOUNT",Description: "Ανεξόφλητο Κεφάλαιο",}
);
instalmentsChildren?.add({
Name: "INSTALMENT AMOUNT",Description: "Ποσό Δόσης",}
);
vars.set({
Name: "INSTALMENTS",Description: "Δόσεις",IsCollection: true,Children: instalmentsChildren,}
, Joove.Common.cast(instalmentsTable?.EmployeeSalaryLoanInstalment, "System.Collections.List"));
return vars;
}
static GetVariables(instalmentsTable: any): any{let vars = new window['Map']();
vars.set("PAYROLL_PERIOD", {
Value: instalmentsTable?.PayrollPeriod?.Name,Description: "Μισθοδοτική Περίοδος",}
);
vars.set("SALARY_PERIOD", {
Value: instalmentsTable?.SalaryPeriod?.Name,Description: "Τύπος Μισθοδοσίας",}
);
return vars;
}
static ResolveCollectionItem(collectionName: any,varName: any,item: any): any{let resp;
resp.Value = "";
if (collectionName == "INSTALMENTS") {let data = Joove.Common.cast(item, "Domain.EmployeeSalaryLoanInstalment");varName = varName?.toUpperCase();switch (varName) {case "CODE":
{
resp.Value = data?.EmployeeSalaryLoan?.Contract?.Employee?.Code;return resp;}
case "EMPLOYEEFULLNAME":
{
resp.Value = data?.EmployeeSalaryLoan?.Contract?.Employee?.Fullname;return resp;}
case "SALARYLOAN_STATUS":
{
resp.Value = data?.EmployeeSalaryLoan?.Status;return resp;}
case "SALARYLOAN_TYPE":
{
resp.Value = data?.EmployeeSalaryLoan?.Type?.Name;return resp;}
case "PRINCIPAL_AMOUNT":
{
resp.Value = data?.EmployeeSalaryLoan?.PrincipalAmount;return resp;}
case "INSTALMENTS_COUNT":
{
resp.Value = data?.EmployeeSalaryLoan?.InstalmentsCount;return resp;}
case "REMAINING_AMOUNT":
{
resp.Value = data?.EmployeeSalaryLoan?.RemainingAmount;return resp;}
case "INSTALMENT_AMOUNT":
{
resp.Value = data?.Amount;return resp;}
default:
{
return resp;}
}}
return resp;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.SalaryLoanInstalmentsExporterKey == null || $this.SalaryLoanInstalmentsExporterKey == 0;
            }


}